import React, { Fragment, useState } from "react"
import _size from "lodash/size"
import classnames from "classnames"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"

import DefaultTitle from "shared/components/DefaultTitle"
import WrapperSkeleton from "components/WrapperSkeleton"
import GeneralProductInformation from "shared/components/GeneralProductInformation"
import Typograph from "components/Typograph"
import DefaultContainer from "shared/components/DefaultContainer"
import FloatLabelSelect from "shared/components/FloatLabelSelect"
import ModernButton from "shared/components/Button/ModernButton"
import EmptyState from "shared/components/EmptyState"
import SelectMult from "shared/components/SelectMult"
import EmailModal from "components/ModernEmailModal"

import { useProductsOptions } from "./utils/useProducts"
import { useDetailsProduct } from "./utils/useDetailsProduct"
import { useBills } from "hooks/useBills"
import { useHandleModalResponse } from "./utils/useHandleModalResponse"
import { formatOptionDate, formatToPayload } from "./utils/formatsDate"
import {
  detailingSend,
  downloadCounts,
  downloadCountsPosPaid
} from "services/state/actions"
import { prepareCountsPosPaid } from "./utils/prepareCountsPosPaid"

import styles from "./styles.css"
import iconError from "assets/svg/erro-desbloqueio.svg"
import InactiveProductsEmptyState from "shared/components/InactiveProductsEmptyState/index"

const DetailingProducts = ({
  useProductsOptions,
  useDetailsProduct,
  useBills,
  loading,
  monthsDetailing,
  detailingSend,
  downloadCountsPosPaid,
  invoices,
  emailCustomer,
  documentNumber
}) => {
  const [paymentDate, setPaymentDate] = useState([])

  const [modals, setModals] = useState({
    email: {
      isOpen: false
    }
  })

  useBills()

  const [optionSelected, options, notFindProductsWithDetail, onChangeOption] =
    useProductsOptions()
  const { selected, productSelected } = optionSelected
  const { value } = selected

  const detailProduct = useDetailsProduct(productSelected, documentNumber)

  useHandleModalResponse(monthsDetailing)

  const { data: monthsDetailsData } = monthsDetailing

  const optionsDate = formatOptionDate(monthsDetailsData)

  const hasDetaling = _size(optionsDate) > 0

  const handleEmailModal = (values) => {
    setModals((prevState) => ({
      ...prevState,
      email: {
        ...prevState.email,
        ...values
      }
    }))
  }

  const sendEmail = (value) => {
    if (!value) return

    const keys = formatToPayload(paymentDate)

    const { productKey, contractKey, serviceId, paymentMode } = productSelected

    detailingSend({
      email: value,
      keys,
      productKey,
      contractKey,
      phoneNumber: serviceId,
      paymentMode
    })
  }

  const downloadDetail = () => {
    const keys = formatToPayload(paymentDate)

    const { productKey, contractKey, serviceId, paymentMode, billingSystem } =
      productSelected

    if (paymentMode !== "POSPAGO") {
      downloadCounts({
        checkeds: keys,
        productKey,
        contractKey,
        serviceId,
        paymentMode,
        billingSystem
      })
    } else {
      const payloads = prepareCountsPosPaid({ keys, productSelected, invoices })
      downloadCountsPosPaid(payloads)
    }
  }

  const inactiveProducts = JSON.parse(
    window.localStorage.getItem("inactiveProducts")
  )

  if (inactiveProducts) {
    return (
      <Fragment>
        <DefaultTitle>Detalhamento de chamadas</DefaultTitle>
        <InactiveProductsEmptyState />
      </Fragment>
    )
  }

  if ((!productSelected || notFindProductsWithDetail) && !loading) {
    return (
      <EmptyState
        icon={iconError}
        description="Ops! Não foi possível prosseguir! Tente novamente ou entre em contato com o nosso atendimento."
      />
    )
  }

  return (
    <Fragment>
      <section className="Grid fullHeight">
        <DefaultTitle>Detalhamento de chamadas</DefaultTitle>
        <WrapperSkeleton path="/automatic-debit" isChildrenReady={!loading}>
          <GeneralProductInformation
            hasSelectOption={false}
            details={detailProduct || {}}
          />
        </WrapperSkeleton>

        <WrapperSkeleton
          path="selectNumberDetailing"
          isChildrenReady={!loading}
        >
          <DefaultContainer customClass={styles.marginTop}>
            <Typograph
              htmlTag="h2"
              weight="bold"
              size="small"
              color="charcoal_grey"
            >
              Selecione o número
            </Typograph>

            <FloatLabelSelect
              id="SELECT_PRODUCT_DETAIL"
              options={options}
              value={value}
              onChange={(e) => onChangeOption(e.target.value)}
              classNames={styles.select}
            />

            <SelectMult
              id="SELECT_DATE_DETAIL"
              name="dates"
              options={optionsDate}
              value={paymentDate}
              onChange={(value) => {
                setPaymentDate(value)
              }}
              placeholder={
                hasDetaling
                  ? "Selecione o período"
                  : "O produto não possui detalhamento"
              }
              classNames={styles.selectMult}
              maxValueAllow={3}
              isDisabled={!hasDetaling}
            />

            <div className={containerButtons}>
              <ModernButton
                shape="outline"
                size="medium"
                buttonColor="deep_sea_green"
                text="Enviar por e-mail"
                textColor="deep_sea_green"
                textSize="small"
                withBorderRadius
                isDisabled={!_size(paymentDate)}
                onClick={() => handleEmailModal({ isOpen: true })}
                classNames={styles.button}
              />
              <ModernButton
                shape="full"
                size="medium"
                buttonColor="deep_sea_green"
                text="Baixar PDF"
                textColor="white"
                textSize="small"
                withBorderRadius
                isDisabled={!_size(paymentDate)}
                onClick={downloadDetail}
              />
            </div>
          </DefaultContainer>
        </WrapperSkeleton>
      </section>
      <EmailModal
        isOpen={modals.email.isOpen}
        email={emailCustomer || ""}
        onClose={() => {
          handleEmailModal({
            isOpen: false
          })
        }}
        onSubmit={(email) => {
          handleEmailModal({
            isOpen: false
          })

          sendEmail(email)
        }}
        confirmButtonTex="Enviar"
      />
    </Fragment>
  )
}

const containerButtons = classnames(
  "u-flex u-flexJustifyEnd",
  styles.containerButton
)

DetailingProducts.propTypes = {
  useBills: PropTypes.func,
  useProductsOptions: PropTypes.func,
  useDetailsProduct: PropTypes.func,
  loading: PropTypes.bool,
  monthsDetailing: PropTypes.shape({
    data: PropTypes.array,
    sendEmails: PropTypes.bool,
    errorSendEmails: PropTypes.bool,
    downloadSucess: PropTypes.bool,
    error: PropTypes.bool
  }),
  detailingSend: PropTypes.func,
  downloadCountsPosPaid: PropTypes.func,
  invoices: PropTypes.array,
  emailCustomer: PropTypes.string,
  documentNumber: PropTypes.string
}

const mapStateToProps = ({
  bills,
  products,
  invoices,
  monthsDetailing,
  customerOpenInvoices,
  customer
}) => ({
  products: products.data,
  loadingBills: bills.loading,
  loadingProducts: products.loading,
  loadingDetails: products.detail.loading,
  loading:
    bills.loading ||
    products.loading ||
    products.detail.loading ||
    invoices.loading ||
    customerOpenInvoices.loading ||
    monthsDetailing.loader,
  invoices: invoices.data,
  monthsDetailing,
  customOpenLoading: customerOpenInvoices.loading,
  emailCustomer: customer.data.email,
  documentNumber: customer.data.documentNumber
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    useProductsOptions,
    useDetailsProduct,
    useBills,
    detailingSend,
    downloadCountsPosPaid
  })
)

export default enhance(DetailingProducts)



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/index.js